import {
  AdminUserLibrary,
  AffiliationAccess,
  LifetimeGrant,
  UserLibraryQuery,
} from '@/service/user/user-types';
import client, { routes } from '@/utils/axios';

export class UserAdminService {
  static async search(query: UserLibraryQuery): Promise<AdminUserLibrary> {
    const res = await client.get<AdminUserLibrary>(routes.user.admin.search, {
      params: query,
    });
    return res.data;
  }

  static async grantLifetime(
    userId: string,
    grant: LifetimeGrant,
  ): Promise<void> {
    await client.post(routes.user.admin.lifetime(userId), grant);
  }

  static async revokeLifetime(userId: string): Promise<void> {
    await client.delete(routes.user.admin.lifetime(userId));
  }

  static async grantAffiliation(
    userId: string,
    alias?: string,
  ): Promise<AffiliationAccess> {
    const res = await client.post<AffiliationAccess>(
      routes.user.admin.affiliation(userId),
      { alias },
    );
    return res.data;
  }

  static async revokeAffiliation(userId: string): Promise<void> {
    await client.delete(routes.user.admin.affiliation(userId));
  }

  static async grantAdmin(userId: string): Promise<void> {
    await client.post(routes.user.admin.admin(userId));
  }

  static async revokeAdmin(userId: string): Promise<void> {
    await client.delete(routes.user.admin.admin(userId));
  }
}
